<template>
  <md-toolbar
    id="toolbar"
    md-elevation="0"
    class="md-fixed"
    :class="{
      [`md-${type}`]: !navbarTransparent,
      [extraNavClasses]: navbarTransparent,
      'md-transparent': navbarTransparent
    }"
    :color-on-scroll="colorOnScroll"
  >
    <div class="md-toolbar-row md-collapse-lateral">
      <div class="md-toolbar-section-start">
        <h3 class="md-title">
          {{ brand }}
        </h3>
      </div>
      <div class="md-toolbar-section-end">
        <md-button
          class="md-just-icon md-simple md-toolbar-toggle"
          :class="{ toggled: toggledClass }"
          @click="toggleNavbarMobile()"
        >
          <span class="icon-bar" />
          <span class="icon-bar" />
          <span class="icon-bar" />
        </md-button>

        <div class="md-collapse">
          <div class="md-collapse-wrapper">
            <mobile-menu nav-mobile-section="false">
            </mobile-menu>
            <md-list>
              <li class="md-list-item">
                <a
                  href="#introduction"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple"
                      >
                        <i class="material-icons">apps</i>
                        <p>Возможности</p>
                      </md-button>
                  </div>
                </a>
              </li>

              <li class="md-list-item">
                <a
                        href="#testimonials"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple"
                        data-toggle="dropdown"
                      >
                        <i class="far fa-comment-dots"></i>
                        <p>Отзывы</p>
                      </md-button>
                  </div>
                </a>
              </li>

              <li class="md-list-item">
                <a
                        href="#price"
                  class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                      <md-button
                        slot="title"
                        class="md-button md-button-link md-white md-simple"
                      >
                        <i class="fas fa-ruble-sign"></i>
                        <p>Цены</p>
                      </md-button>
                  </div>
                </a>
              </li>
              <li class="md-list-item">
                <a
                        href="#support"
                        class="md-list-item-router md-list-item-container md-button-clean dropdown"
                >
                  <div class="md-list-item-content">
                    <md-button
                            slot="title"
                            class="md-button md-button-link md-white md-simple"
                    >
                      <i class="fas fa-user-cog"></i>
                      <p>Поддержка</p>
                    </md-button>
                  </div>
                </a>
              </li>
              <li class="md-list-item">
                  <router-link
                            to="evotor"
                            class="md-list-item-router md-list-item-container md-button-clean dropdown"
                    >
                        <div class="md-list-item-content" >
                            <md-button
                                    slot="title"
                                    class="md-button md-button-link  md-white md-simple cust-ico"
                            >
<!--                                <i class="fas fa-user-cog"></i>-->
                                <i class="fas fa-receipt"></i>
                                <p>Для ЭВОТОР</p>
                            </md-button>
                        </div>
                  </router-link>
                </li>
              <li class="md-list-item" >
                <a
                  href="#connect"
                  class="md-list-item-router md-list-item-container md-button-clean"
                >
                  <div class="md-list-item-content">
                    <md-button
                      class="md-success md-round"
                    >Установить</md-button>
                  </div>
                </a>
              </li>
            </md-list>
          </div>
        </div>
      </div>
    </div>
  </md-toolbar>
</template>

<script>
let resizeTimeout;
function resizeThrottler(actualResizeHandler) {
  // ignore resize events as long as an actualResizeHandler execution is in the queue
  if (!resizeTimeout) {
    resizeTimeout = setTimeout(() => {
      resizeTimeout = null;
      actualResizeHandler();

      // The actualResizeHandler will execute at a rate of 15fps
    }, 65);
  }
}

import MobileMenu from "@/layout/MobileMenu";
export default {
  components: {
    MobileMenu
  },
  props: {
    type: {
      type: String,
      default: "white",
      validator(value) {
        return [
          "white",
          "default",
          "primary",
          "danger",
          "success",
          "warning",
          "info",
          "dark"
        ].includes(value);
      }
    },
    colorOnScroll: {
      type: Number,
      default: 0
    },
    navbarTransparent: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      extraNavClasses: "",
      toggledClass: false,
      brand: "AkiTorg Мобильная торговля",
    };
  },
  computed: {
    showDownload() {
      const excludedRoutes = ["index"];
      return excludedRoutes.every(r => r !== this.$route.name);
    }
  },
  mounted() {
    document.addEventListener("scroll", this.scrollListener);
    this.scrollToLink()
  },
  beforeDestroy() {
    document.removeEventListener("scroll", this.scrollListener);
  },
  methods: {
    scrollToLink () {
      let path = this.$route.path
      if (path === '/support') {
        this. scrollMeTo('support')
      }
      if (path === '/price') {
        this. scrollMeTo('price')
      }
      if (path === '/testimonials') {
        this. scrollMeTo('testimonials')
      }
      if (path === '/introduction') {
        this. scrollMeTo('introduction')
      }
    },
    scrollMeTo(refName) {
      var element = document.getElementById(refName)
      var top = element.offsetTop + 600;
      window.scrollTo(0, top);
    },
    bodyClick() {
      let bodyClick = document.getElementById("bodyClick");

      if (bodyClick === null) {
        let body = document.querySelector("body");
        let elem = document.createElement("div");
        elem.setAttribute("id", "bodyClick");
        body.appendChild(elem);

        let bodyClick = document.getElementById("bodyClick");
        bodyClick.addEventListener("click", this.toggleNavbarMobile);
      } else {
        bodyClick.remove();
      }
    },
    toggleNavbarMobile() {
      this.NavbarStore.showNavbar = !this.NavbarStore.showNavbar;
      this.toggledClass = !this.toggledClass;
      this.bodyClick();
    },
    handleScroll() {
      let scrollValue =
        document.body.scrollTop || document.documentElement.scrollTop;
      let navbarColor = document.getElementById("toolbar");
      this.currentScrollValue = scrollValue;
      if (this.colorOnScroll > 0 && scrollValue > this.colorOnScroll) {
        this.extraNavClasses = `md-${this.type}`;
        navbarColor.classList.remove("md-transparent");
      } else {
        if (this.extraNavClasses) {
          this.extraNavClasses = "";
          navbarColor.classList.add("md-transparent");
        }
      }

    },
    scrollListener() {
      resizeThrottler(this.handleScroll);
    }
  }
};
</script>

<style lang="scss">
</style>